<app-sidenav page="product-confirm" data="{{ product?.getId() }}" menuType>

<div class="form-list">

<div class="product-page">
<mat-card class="product-card">
  <mat-card-header>
    <mat-card-title>{{ product?.getName() }}</mat-card-title>
  </mat-card-header>
  <mat-card-footer [class]="'product-price'">
    <span *ngIf="product_qty">{{ 'product.qty' | translate }} {{ product_qty }}</span>
    {{ ((product?.getPrice() | number:'1.2-2') || '').replace(',',' ').replace('.',',') }}{{ currencysymbol }}
  </mat-card-footer>
</mat-card>

<ng-image-slider
  class="img-slider"
  [imageSize]="imageSize"
  [manageImageRatio]="true"
  [images]="imageObject" #nav>
</ng-image-slider>

<div #boxOption class="box-options" *ngIf="colorVariants.length > 0; else fallbackOptions">
  <!-- Color Selector Row -->
  <div class="variant-row">
    <span class="label">{{ 'product.color_label' | translate }}</span>
    <div class="color-chips">
      <button
        type="button"
        *ngFor="let item of colorVariants"
        (click)="selectColor(item.label)"
        [disabled]="product?.getQtyn() ? item.totalQty <= 0 : false"
        [attr.aria-pressed]="orderForm.color"
        class="color-chip"
        [class.color-chip--selected]="orderForm.color === item.label">
          <span class="color-chip__swatch" [style.background-color]="item.bgcolor">
            <span
              *ngIf="orderForm.color === item.label"
              class="color-chip__check"
              [style.color]="item.fgcolor">✓</span>
          </span>
          <span class="color-chip__label">
            {{ ('colors.COLOR_' + item.label) | translate }}
          </span>
      </button>
    </div>
  </div>

  <!-- Size Availability Grid for Selected Color -->
  <div class="variant-row" *ngIf="orderForm.color && activeVariantSizes.length > 0">
    <span class="label">{{ 'product.size_label' | translate }}</span>
    <div class="size-table">
      <button
        type="button"
        *ngFor="let item of activeVariantSizes"
        (click)="selectSize(item.size)"
        [disabled]="product?.getQtyn() ? item.qty <= 0 : false"
        class="size-box color-chip"
        [class.color-chip--selected]="orderForm.size === item.size"
        [class.size-box--oos]="item.qty === 0">
        <span class="size-box__size">{{ item.size }}</span>
        <span class="size-box__qty">
          {{ item.qty > 0 ? (item.qty  + ' ' + ('product.left' | translate)) : ('product.qty0' | translate) }}
        </span>
      </button>
    </div>
  </div>

  <!-- Quantity + Total -->
  <div class="variant-row order-row">
    <span class="label">{{ 'product-confirm.quantity' | translate }}</span>
    <div class="flex">
    {{ orderForm.qtyOK }}
    <mat-form-field class="qty-select" appearance="outline">
      <mat-select [(ngModel)]="orderForm.qtySelect">
        <mat-option
          (click)="updateOrder()"
          *ngFor="let s of '1,2,3,4,5,product-confirm.Other'.split(',')"
          [value]="s">{{ s | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
    </div>
  </div>

  <div class="order-total">
    <span class="order-total__label">{{ 'product-confirm.total' | translate }}</span>
    <span class="order-total__value">
      {{ total }} {{ currencysymbol }}
    </span>
  </div>
</div>

<ng-template #fallbackOptions></ng-template>
</div>
<div class="bottom">
  <button (click)="addProductToCart()" mat-raised-button [class]="'button-confirm'">{{ 'product-confirm.button' | translate }}</button>
</div>

</div>

<app-ctl-qty-dialog
  [showQty]="orderForm"
  (okclick)="qtyOK()"
  *ngIf="orderForm.show"></app-ctl-qty-dialog>

</app-sidenav>